import {Component, OnInit} from '@angular/core';
import {RouterPathService} from '../../../core/common/variables/router-path.service';
import {TranslateService} from '../../common/variables/translate-service';
import {ImagePathService} from '../../../core/common/variables/image-path.service';
import {ActivatedRoute, Router} from '@angular/router';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators
} from '@angular/forms';
import {MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {CommonFormValidator} from '../../common/services/form-validation.service';
import {GlobalVariableService} from '../../common/variables/global-variable';
import {Store} from '@ngrx/store';
import {Observable, Subscription} from 'rxjs';
import {SC_Input} from '../../common/input/SC_Input';
import {GlobalService} from '../../common/services/global.service';
import {RoofParameterService} from '../../common/roof/roof-parameter.service';
import {clearSelectProject, selectProject} from '../../store/senAppProjects.action';
import {Actions, ofType} from '@ngrx/effects';
import {ConfirmationBoxComponent} from '../../common/components/confirmation-box/confirmation-box.component';
import {GlobalFunctionService} from '../../common/services/global-function.service';
import {ProjectSaveInput} from '../../common/api/ProjectSave';
import {InputBase} from '../../common/api/common/InputBase';
import {ProjectGetData, ProjectGetRoofPlan} from '../../common/api/ProjectGet';
import {TypeAddress} from '../../common/api/common/TypeAddress';
import * as windZonePaths from './zone-map/wind-zones.json';
import * as snowZonePaths from './zone-map/snow-zones.json';
import {NgbPopover} from '@ng-bootstrap/ng-bootstrap';
import {Statics} from '../../common/utilities/statics';
import {ChangeDetectorRef} from '@angular/core';


@Component({
  selector: 'sen-app-create-project',
  templateUrl: './create-project.component.html',
  styleUrls: ['./create-project.component.scss']
})
export class CreateProjectComponent implements OnInit {
  MPProjectPath: string;
  roofPlanPath: string;
  windZones: string[] = ['1', '2', '3', '4'];
  windZonePath = (windZonePaths as any).default;
  snowZonePath = (snowZonePaths as any).default;
  snowZones: string[] = ['1', '1a', '2', '2a', '3'];
  terrainCat: { label: string, value: string }[] = [{label: '1', value: '0'}, {label: '2', value: '1'}];
  selectedProject$: Observable<any>;
  selectedProjectUnSubscribe: Subscription;
  roofPlanArray: boolean = false;
  selectedProject: ProjectGetData;
  public windZonesValue: string;
  public snowZonesValue: string;
  public terrainCatValue: string;
  form: FormGroup;
  sourceAction: string;
  address: TypeAddress;
  routerUnSubscribe: Subscription;
  parentFormSubmitted: boolean = false;
  triggerStaticsChange: any;
  getWindData: any;
  getSnowData: any;
  getTerrainData: any;
  windResult: string = 'Wind Zone Information';
  snowResult: string = 'Snow Zone Information';
  terrainResult: string = 'Terrain Zone Information';
  isWindZoneSelected = false;
  isSnowZoneSelected = false;
  isTerrainZoneSelected = false;
  isManualAddress: boolean = false;
  checkboxValue: any;

  constructor(
    public routerPath: RouterPathService,
    public dialog: MatDialog,
    private action: Actions,
    public imagePath: ImagePathService,
    private formBuilder: FormBuilder,
    public global: GlobalVariableService,
    public globalService: GlobalService,
    public globalF: GlobalFunctionService,
    private activeRoute: ActivatedRoute,
    private roofParams: RoofParameterService,
    public translate: TranslateService,
    private cdref: ChangeDetectorRef,
    private router: Router,
    private store: Store<any>) {
    this.selectedProject$ = this.store.select(state => {
      return state.appData.selectedProject;
    });
    this.MPProjectPath = this.routerPath.MPProjectPath;
    this.roofPlanPath = this.routerPath.RPMountingPath;
    this.form = this.formBuilder.group({
        projectName: new FormControl(null, [Validators.required, Validators.maxLength(this.global.maxStringLength), Validators.minLength(this.global.minStringLength)]),
        projectWindloadZone: new FormControl(null, [Validators.required]),
        projectSnowloadZone: new FormControl(null, Validators.required),
        projectTerrain: new FormControl(null, Validators.required),
        projectTerrainHeight: new FormControl(null, Validators.required),
        projectNorthGermanPlain: new FormControl(null, Validators.nullValidator),
        metaChange: new FormControl(false, Validators.required),
        full: new FormControl('', Validators.required),

      },
      {

        validator: CommonFormValidator.checkzone
      });


  }

  ngOnInit(): void {
    this.routerUnSubscribe = this.activeRoute.queryParams.subscribe(params => {
      this.sourceAction = params.action;
      if (this.checkSelectedProject()) {
        this.setSelectedProjectValue();
      } else {
        this.store.dispatch(clearSelectProject());
      }
    });
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  ngOnDestroy() {
    this.routerUnSubscribe.unsubscribe();
    if (this.selectedProjectUnSubscribe) {
      this.selectedProjectUnSubscribe.unsubscribe();
    }
  }

  checkSelectedProject() {
    return this.sourceAction == this.global.editProject;
  }

  setSelectedProjectValue() {
    this.selectedProjectUnSubscribe = this.selectedProject$.subscribe((data: any) => {
      if (data) {
        this.roofPlanArray = true;
        this.selectedProject = data;
        this.form.get('projectName')!.setValue(data.name);
        this.form.get('projectWindloadZone')!.setValue(data.windZone);
        this.form.get('projectSnowloadZone')!.setValue(data.snowZone);
        this.form.get('projectTerrain')!.setValue(data.terrainCategory);
        this.form.get('projectTerrainHeight')!.setValue(data.terrainHeight);
        if (data.isNorthGermanPlain) {
          this.form.get('projectNorthGermanPlain')!.setValue(true);
        } else {
          this.form.get('projectNorthGermanPlain')!.setValue(false);
        }
        this.form.get('metaChange')!.setValue(true);
        this.form.get('full')?.setValue(data.address.full);
        this.address = data.address;
      }
    });
  }

  setTerrainHeight(event: number) {
    this.form.get('projectTerrainHeight')!.setValue(event);
  }

  setAddress(event: TypeAddress) {
    this.address = event;
    this.form.get('full')?.setValue(this.address.full);
    this.form.markAsDirty();
  }

  resetZoneValue() {
    if (this.checkSelectedProject()) {
      this.setSelectedProjectValue();
    } else {
      //api call goes here
    }
  }

  confirmAndsaveProject(code: string) {
    let dialogRef = this.globalF.openConfirmationBox(code);
    dialogRef.afterClosed().subscribe((result: boolean) => {
      dialogRef.close();
      if (result) {
        this.form.get('metaChange')?.setValue(!result);
        this.saveProject();
      }
    });
  }

  askDifferentName(message: string) {
    let dialogRef = this.globalF.openInputBox(this.translate.getLng('PROJECT_NAME'), message, this.translate.getLng('SAVE'));
    dialogRef.afterClosed().subscribe((result: any) => {
      dialogRef.close();
      if (result.action) {
        this.form.get('projectName')?.setValue(result.name);
        this.saveProject();
      }
    });
  }

  saveProject(path?: string) {
    this.form.markAllAsTouched();
    if (this.form.invalid || this.form.pristine) {
      this.parentFormSubmitted = true;
      return;
    } else {
      this.parentFormSubmitted = false;
    }

    this.checkboxValue = localStorage.getItem('getcheckboxValue');
    this.checkboxValue = JSON.parse(this.checkboxValue);
    let isNorthGermanPlain = false;
    if (this.form.get('projectNorthGermanPlain')!.value) {
      isNorthGermanPlain = true;
    }
    let option: ProjectSaveInput = {
      name: this.form.get('projectName')!.value,
      windZone: this.form.get('projectWindloadZone')!.value,
      snowZone: this.form.get('projectSnowloadZone')!.value,
      terrainCategory: this.form.get('projectTerrain')!.value,
      terrainHeight: this.form.get('projectTerrainHeight')!.value,
      isNorthGermanPlain: isNorthGermanPlain,
      metaDataCheck: this.form.get('metaChange')!.value,
      version: 1,
      id: this.checkSelectedProject() ? SC_Input.sProject.selectedProject.id : 0,
      address: this.address,
      isManualAddress: this.checkboxValue,
    };
    const qParam: InputBase = {
      cmd: this.global.projectSave
    };

    this.globalService.postData(qParam, option).subscribe(data => {
      if (data && data.ok) {
        this.router.navigate([this.routerPath.manageProjectPath], {
          state: {action: this.sourceAction}
        });
      } else if (data.error?.code) {
        if (data.error.code == this.global.metadataChange) {
          this.confirmAndsaveProject(data.error.code);
        } else {
          this.askDifferentName(data.error.message);
        }
      }
      ;
    });
  }

  cancelProject(path: string) {
    //clears selected project oninit and just to restore the existing project save plan used
    this.router.navigate([path], {
      state: {action: this.global.savePlan}
    });
  }

  windZoneInfo(popOver: NgbPopover) {
    //console.log('windResult',this.windResult);
    if (this.windResult) {
      popOver.open();
    }

  }

  snowZoneInfo(popOver: NgbPopover) {
    if (this.snowResult) {
      popOver.open();
    }

  }

  terrainZoneInfo(popOver: NgbPopover) {
    if (this.terrainResult) {
      popOver.open();
    }

  }


  getWindval(result: any) {
    if (result) {
      //console.log('windResult',this.windResult);
      this.windResult = this.windResult;
      this.isWindZoneSelected = true;
    }
  }

  getSnowval(result: any) {
    if (result) {
      this.snowResult = this.snowResult;
      this.isSnowZoneSelected = true;
    }
  }

  getTerrainval(result: any) {
    if (result) {
      this.terrainResult = this.terrainResult;
      this.isTerrainZoneSelected = true;
    }
  }
}







